export const nouns = [
    {
        'id': 'noun/die-Uhr',
        'word': 'Uhr, die',
        'english': 'clock, watch, o\'clock',
        'sentence': 'Ich gehe jeden Tag um acht Uhr zur Arbeit.',
        't': 'I go to work at eight o\'clock every day.'
    },
    {
        'id': 'noun/das-Jahr',
        'word': 'Jahr, das',
        'english': 'year',
        'sentence': 'Ein Jahr hat zwölf Monate.',
        't': 'One year has twelve months.'
    },
    {
        'id': 'noun/der-Euro',
        'word': 'Euro, der',
        'english': 'euro',
        'sentence': 'In der Kasse fehlen 100 (hundert) Euro.',
        't': '100 euros are missing from the cash register.'
    },
    {
        'id': 'noun/der-Mensch',
        'word': 'Mensch, der',
        'english': 'human (being), person, man, people',
        'sentence': 'Jeder Mensch ist einzigartig.',
        't': 'Every human being is unique.'
    },
    {
        'id': 'noun/das-Kind',
        'word': 'Kind, das',
        'english': 'child, kid',
        'sentence': 'Die Mutter setzt ihr Kind in den Kinderwagen.',
        't': 'The mother puts her child in the pram.'
    },
    {
        'id': 'noun/der-Tag',
        'word': 'Tag, der',
        'english': 'day',
        'sentence': 'der Tag ↔ die Nacht',
        't': 'day ↔ night'
    },
    {
        'id': 'noun/die-Stadt',
        'word': 'Stadt, die',
        'english': 'city, town',
        'sentence': 'Heute war ich in der Stadt einkaufen.',
        't': 'Today I was shopping in town.'
    },
    {
        'id': 'noun/die-Zeit',
        'word': 'Zeit, die',
        'english': 'time',
        'sentence': 'Tut mir leid, Ich habe keine Zeit.',
        't': 'I\'m sorry, I don\'t have time.'
    },
    {
        'id': 'noun/das-Prozent',
        'word': 'Prozent, das',
        'english': 'per cent, percent, percentage',
        'sentence': 'Ganz egal, was ich tue, ich gebe immer 100 (hundert) Prozent!',
        't': 'No matter what I do, I always give 100 percent!'
    },
    {
        'id': 'noun/das-Foto',
        'word': 'Foto, das',
        'english': 'photograph, photo, picture, shot',
        'sentence': 'Machst du jedes Mal ein Foto von deinem Essen?',
        't': 'Do you take a picture of your food every time?'
    },
    {
        'id': 'noun/die-Frau',
        'word': 'Frau, die',
        'english': 'woman, wife, Mrs.',
        'sentence': 'Meine Tante Elke ist eine tolle Frau!',
        't': 'My aunt Elke is a great woman!'
    },
    {
        'id': 'noun/die-Woche',
        'word': 'Woche, die',
        'english': 'week',
        'sentence': 'Eine Woche hat sieben Tage.',
        't': 'One week has seven days.'
    },
    {
        'id': 'noun/das-Ende',
        'word': 'Ende, das',
        'english': 'end',
        'sentence': 'Fahren Sie immer geradeaus bis zum Ende der Straße.',
        't': 'Keep going straight to the end of the street.'
    },
    {
        'id': 'noun/der-Mann',
        'word': 'Mann, der',
        'english': 'man, husband',
        'sentence': 'Heute sind mein Mann und ich vier Jahre verheiratet.',
        't': 'Today, my husband and I have been married for four years.'
    },
    {
        'id': 'noun/der-Sonntag',
        'word': 'Sonntag, der',
        'english': 'Sunday',
        'sentence': 'Sieben Tage von Montag bis Sonntag sind eine Woche.',
        't': 'Seven days from Monday to Sunday are one week.'
    },
    {
        'id': 'noun/das-Land',
        'word': 'Land, das',
        'english': 'land, country, state, countryside, nation',
        'sentence': 'Deutschland ist ein Land in der Mitte von Europa.',
        't': 'Germany is a country in the middle of Europe.'
    },
    {
        'id': 'noun/das-Deutschland',
        'word': 'Deutschland, das',
        'english': 'Germany',
        'sentence': 'In Deutschland besteht eine Postleitzahl aus fünf Ziffern.',
        't': 'In Germany, a postcode consists of five digits.'
    },
    {
        'id': 'noun/das-Haus',
        'word': 'Haus, das',
        'english': 'house, home, building',
        'sentence': 'In diesem Haus wohne ich.',
        't': 'I live in this house.'
    },
    {
        'id': 'noun/der-Platz',
        'word': 'Platz, der',
        'english': 'place, space, room, square, seat',
        'sentence': 'Entschuldigung, ist dieser Platz frei?',
        't': 'Excuse me, is this seat free?'
    },
    {
        'id': 'noun/das-Spiel',
        'word': 'Spiel, das',
        'english': 'game, match, play',
        'sentence': 'Wollen wir ein Spiel spielen?',
        't': 'Shall we play a game?'
    },
    {
        'id': 'noun/die-Million',
        'word': 'Million, Mio.',
        'english': 'million',
        'sentence': 'Eine Million hat sechs Nullen, eine Milliarde hat neun Nullen und eine Billion hat zwölf Nullen.',
        't': 'A million has six zeros, a billion has nine zeros and a trillion has twelve zeros.'
    },
    {
        'id': 'noun/der-Fall',
        'word': 'Fall, der',
        'english': 'fall, case',
        'sentence': 'Der Detektiv hat den Fall gelöst.',
        't': 'The detective solved the case.'
    },
    {
        'id': 'noun/das-Leben',
        'word': 'Leben, das',
        'english': 'life',
        'sentence': 'das Leben ↔ der Tod',
        't': 'life ↔ death'
    },
    {
        'id': 'noun/das-Bild',
        'word': 'Bild, das',
        'english': 'picture, image, painting',
        'sentence': 'Was soll das Bild darstellen? - Eine glückliche Familie!',
        't': 'What is the picture supposed to represent? - A happy family!'
    },
    {
        'id': 'noun/das-Thema',
        'word': 'Thema, das',
        'english': 'subject, topic, theme, issue',
        'sentence': 'Können wir bitte das Thema wechseln?',
        't': 'Can we please change the subject?'
    },
    {
        'id': 'noun/der-Monat',
        'word': 'Monat, der',
        'english': 'month',
        'sentence': 'In welchem Monat hast du Geburtstag?',
        't': 'Which month is your birthday in?'
    },
    {
        'id': 'noun/die-Frage',
        'word': 'Frage, die',
        'english': 'question',
        'sentence': 'Entschuldigung, ich habe eine Frage!',
        't': 'Excuse me, I have a question!'
    },
    {
        'id': 'noun/die-Arbeit',
        'word': 'Arbeit, die',
        'english': 'work, job, labour, labor, paper',
        'sentence': 'Ich fahre jeden Tag mit dem Bus zur Arbeit.',
        't': 'I go to work by bus every day.'
    },
    {
        'id': 'noun/die-Minute',
        'word': 'Minute, die',
        'english': 'minute',
        'sentence': 'Eine Minute hat 60 (sechzig) Sekunden.',
        't': 'One minute has 60 seconds.'
    },
    {
        'id': 'noun/die-Schule',
        'word': 'Schule, die',
        'english': 'school',
        'sentence': 'Gehst du gerne zur Schule?',
        't': 'Do you like going to school?'
    },
    {
        'id': 'noun/der-Teil',
        'word': 'Teil, der',
        'english': 'part, piece, section, share',
        'sentence': 'Jeder bekommt seinen Teil.',
        't': 'Everyone gets their share.'
    },
    {
        'id': 'noun/das-Teil',
        'word': 'Teil, das',
        'english': 'part, piece, particle, component',
        'sentence': 'Dieses Teil ist defekt. Wir werden es durch ein Neues ersetzen.',
        't': 'This part is defective. We will replace it with a new one.'
    },
    {
        'id': 'noun/die-Seite',
        'word': 'Seite, die',
        'english': 'side, page',
        'sentence': 'Das Rezept findest du im Kochbuch auf Seite 23 (dreiundzwanzig).',
        't': 'You can find the recipe in the cookbook on page 23.'
    },
    {
        'id': 'noun/das-Unternehmen',
        'word': 'Unternehmen, das',
        'english': 'enterprise, company, business, firm',
        'sentence': 'Das Unternehmen wurde 2010 (zweitausendzehn) gegründet.',
        't': 'The company was founded in 2010.'
    },
    {
        'id': 'noun/das-Mal',
        'word': 'Mal, das',
        'english': 'time',
        'sentence': 'Machst du jedes Mal ein Foto von deinem Essen?',
        't': 'Do you take a picture of your food every time?'
    },
    {
        'id': 'noun/die-Welt',
        'word': 'Welt, die',
        'english': 'world',
        'sentence': 'Ich würde gerne eine Reise um die Welt machen.',
        't': 'I would like to take a trip around the world.'
    },
    {
        'id': 'noun/der-Grund',
        'word': 'Grund, der',
        'english': 'reason, cause, occasion, bottom, ground',
        'sentence': 'Aus welchem Grund kommt Tom heute nicht zur Arbeit?',
        't': 'For what reason is Tom not coming to work today?'
    },
    {
        'id': 'noun/das-Problem',
        'word': 'Problem, das',
        'english': 'problem',
        'sentence': 'Das ist ein ernstes Problem.',
        't': 'That is a serious problem.'
    },
    {
        'id': 'noun/das-Beispiel',
        'word': 'Beispiel, das',
        'english': 'example',
        'sentence': 'Könnten Sie mir ein Beispiel nennen / geben / sagen?',
        't': 'Could you give me an example?'
    },
    {
        'id': 'noun/das-Wort',
        'word': 'Wort, das',
        'english': 'word',
        'sentence': 'Die Sache ist geheim. Kein Wort, zu niemandem!',
        't': 'The matter is secret. Not a word, to anyone!'
    },
    {
        'id': 'noun/die-Art',
        'word': 'Art, die',
        'english': 'kind, type, sort, way, nature, species',
        'sentence': 'Welche Art von Filmen magst Du?',
        't': 'What kind of movies do you like?'
    },
    {
        'id': 'noun/die-Sache',
        'word': 'Sache, die',
        'english': 'thing, matter, cause',
        'sentence': 'Ich habe kein gutes Gefühl bei der Sache.',
        't': 'I don\'t have a good feeling about this.'
    },
    {
        'id': 'noun/der-Bereich',
        'word': 'Bereich, der',
        'english': 'area, region, field, sector, scope',
        'sentence': 'Ich habe in diesem Bereich bereits viele Erfahrungen gesammelt.',
        't': 'I have already gained a lot of experience in this field.'
    },
    {
        'id': 'noun/der-Weg',
        'word': 'Weg, der',
        'english': 'path, way, route, road, trail',
        'sentence': 'Wo ein Wille ist, ist auch ein Weg.',
        't': 'Where there\'s a will, there\'s a way.'
    },
    {
        'id': 'noun/das-Geld',
        'word': 'Geld, das',
        'english': 'money',
        'sentence': 'Könntest du mir etwas Geld leihen?',
        't': 'Could you lend me some money?'
    },
    {
        'id': 'noun/die-Geschichte',
        'word': 'Geschichte, die',
        'english': 'history, story',
        'sentence': 'Das Buch erzählt eine spannende Geschichte.',
        't': 'The book tells an exciting story.'
    },
    {
        'id': 'noun/die-Stunde',
        'word': 'Stunde, die',
        'english': 'hour, lesson',
        'sentence': 'Eine Stunde hat 60 (sechzig) Minuten.',
        't': 'One hour has 60 minutes.'
    },
    {
        'id': 'noun/der-Name',
        'word': 'Name, der',
        'english': 'name',
        'sentence': 'Darf ich mich vorstellen? Mein Name ist Markus Meier.',
        't': 'May I introduce myself? My name is Markus Meier.'
    },
    {
        'id': 'noun/das-Paar',
        'word': 'Paar, das',
        'english': 'pair, couple',
        'sentence': 'Tom und Sarah sind seit drei Monaten ein Paar.',
        't': 'Tom and Sarah have been a couple for three months.'
    },
    {
        'id': 'noun/der-Kopf',
        'word': 'Kopf, der',
        'english': 'head, mind',
        'sentence': 'Kopf, Arme, Hände, Beine, Füße, Bauch und Rücken sind Körperteile.',
        't': 'Head, arms, hands, legs, feet, stomach and back are body parts.'
    },
    {
        'id': 'noun/die-Gesellschaft',
        'word': 'Gesellschaft, die',
        'english': 'society, company',
        'sentence': 'Isst du lieber alleine oder in Gesellschaft?',
        't': 'Do you prefer eating alone or in company?'
    },
    {
        'id': 'noun/die-Leute',
        'word': 'Leute, die',
        'english': 'people, folk(s)',
        'sentence': 'Viele Leute haben heute kein Telefon mehr, sondern nur ein Handy.',
        't': 'Many people today no longer have a telephone, but only a mobile.'
    },
    {
        'id': 'noun/die-Stelle',
        'word': 'Stelle, die',
        'english': 'place, position, location, job',
        'sentence': 'Von dieser Stelle aus hat man eine herrliche Aussicht.',
        't': 'There is a magnificent view from this point.'
    },
    {
        'id': 'noun/die-Möglichkeit',
        'word': 'Möglichkeit, die',
        'english': 'possibility, opportunity, way, option, chance',
        'sentence': 'Gibt es die Möglichkeit das Produkt vor dem Kauf zu testen?',
        't': 'Is there a possibility to test the product before buying?'
    },
    {
        'id': 'noun/die-Form',
        'word': 'Form, die',
        'english': 'form, shape',
        'sentence': 'Welche Form hat die Erde?',
        't': 'What shape is the earth?'
    },
    {
        'id': 'noun/das-Wasser',
        'word': 'Wasser, das',
        'english': 'water',
        'sentence': 'Ich hätte gerne ein Glas Wasser.',
        't': 'I would like a glass of water.'
    },
    {
        'id': 'noun/das-Buch',
        'word': 'Buch, das',
        'english': 'book',
        'sentence': 'Das Buch erzählt eine spannende Geschichte.',
        't': 'The book tells an exciting story.'
    },
    {
        'id': 'noun/der-Abend',
        'word': 'Abend, der',
        'english': 'evening',
        'sentence': 'Wie war das Konzert gestern Abend?',
        't': 'How was the concert last night?'
    },
    {
        'id': 'noun/die-Entwicklung',
        'word': 'Entwicklung, die',
        'english': 'development',
        'sentence': 'In meiner Stadt hat die Kriminalität massiv zugenommen. Diese Entwicklung beunruhigt mich sehr.',
        't': 'There has been a massive increase in crime in my city. I am very concerned about this development.'
    },
    {
        'id': 'noun/der-Morgen',
        'word': 'Morgen, der',
        'english': 'morning',
        'sentence': 'Guten Morgen, hast du gut geschlafen?',
        't': 'Good morning, did you sleep well?'
    },
    {
        'id': 'noun/die-Hand',
        'word': 'Hand, die',
        'english': 'hand',
        'sentence': 'Jede Hand hat fünf Finger.',
        't': 'Each hand has five fingers.'
    },
    {
        'id': 'noun/der-Sinn',
        'word': 'Sinn, der',
        'english': 'sense, meaning, purpose, mind',
        'sentence': 'Manchmal macht das Leben einfach keinen Sinn.',
        't': 'Sometimes life just doesn\'t make sense.'
    },
    {
        'id': 'noun/die-Familie',
        'word': 'Familie, die',
        'english': 'family',
        'sentence': 'Liebe Grüße von der ganzen Familie!',
        't': 'Love from the whole family!'
    },
    {
        'id': 'noun/die-Aufgabe',
        'word': 'Aufgabe, die',
        'english': 'task, assignment, job',
        'sentence': 'Ist diese Aufgabe bereits erledigt?',
        't': 'Is this task already done?'
    },
    {
        'id': 'noun/die-Universität',
        'word': 'Universität, die',
        'english': 'university',
        'sentence': 'An der Universität Bremen studieren derzeit rund 20.000 Studentinnen und Studenten in 80 (achtzig) Studiengängen.',
        't': 'Around 20,000 students are currently studying on 80 degree programmes at the University of Bremen.'
    },
    {
        'id': 'noun/die-Person',
        'word': 'Person, die',
        'english': 'person',
        'sentence': 'Ein Doppelbett ist ein Bett für zwei Personen.',
        't': 'A double bed is a bed for two people.'
    },
    {
        'id': 'noun/das-Ziel',
        'word': 'Ziel, das',
        'english': 'destination, goal, aim, target',
        'sentence': 'Stefan erreicht das Ziel als Erster.',
        't': 'Stefan reaches the goal first.'
    },
    {
        'id': 'noun/der-Staat',
        'word': 'Staat, der',
        'english': 'state, country',
        'sentence': 'Die amerikanische Flagge hat 13 (dreizehn) Streifen und einen Stern für jeden der 50 (fünfzig) Staaten.',
        't': 'The American flag has 13 stripes and a star for each of the 50 states.'
    },
    {
        'id': 'noun/der-Freund',
        'word': 'Freund, der',
        'english': 'friend, boyfriend',
        'sentence': 'der Freund ↔ der Feind',
        't': 'friend ↔ enemy'
    },
    {
        'id': 'noun/das-Ding',
        'word': 'Ding, das',
        'english': 'thing, item',
        'sentence': 'Neben der Arbeit bleibt wenig Zeit für andere Dinge.',
        't': 'Besides work, there is little time for other things.'
    },
    {
        'id': 'noun/der-Raum',
        'word': 'Raum, der',
        'english': 'room, space',
        'sentence': 'Das Wohnzimmer ist meist der größte Raum der Wohnung.',
        't': 'The living room is usually the largest room in the flat.'
    },
    {
        'id': 'noun/die-Nacht',
        'word': 'Nacht, die',
        'english': 'night',
        'sentence': 'der Tag ↔ die Nacht',
        't': 'day ↔ night'
    },
    {
        'id': 'noun/die-Eltern',
        'word': 'Eltern, die',
        'english': 'parents',
        'sentence': 'Meine Eltern sind geschieden.',
        't': 'My parents are divorced.'
    },
    {
        'id': 'noun/das-System',
        'word': 'System, das',
        'english': 'system',
        'sentence': 'Das System überwacht das Gebäude und alarmiert Sie im Fall eines Brandes oder Einbruchs.',
        't': 'The system monitors the building and alerts you in case of fire or burglary.'
    },
    {
        'id': 'noun/der-Blick',
        'word': 'Blick, der',
        'english': 'look, view, glance, gaze',
        'sentence': 'Maria wirft einen Blick in den Kühlschrank.',
        't': 'Maria takes a look in the refrigerator.'
    },
    {
        'id': 'noun/der-Herr',
        'word': 'Herr, der',
        'english': 'man, Mr, gentleman',
        'sentence': 'Herr Walter trägt Bart und Brille.',
        't': 'Mr Walther wears a beard and glasses.'
    },
    {
        'id': 'noun/die-Zahl',
        'word': 'Zahl, die',
        'english': 'number',
        'sentence': 'Man sagt, die Zahl 13 (dreizehn) bringt Unglück.',
        't': 'They say the number thirteen brings bad luck.'
    },
    {
        'id': 'noun/die-Straße',
        'word': 'Straße, die',
        'english': 'road, street',
        'sentence': 'Die Kinder spielen auf der Straße.',
        't': 'The children are playing in the street.'
    },
    {
        'id': 'noun/das-Gesicht',
        'word': 'Gesicht, das',
        'english': 'face',
        'sentence': 'Spürst du den Wind im Gesicht?',
        't': 'Do you feel the wind in your face?'
    },
    {
        'id': 'noun/die-Sprache',
        'word': 'Sprache, die',
        'english': 'language, speech',
        'sentence': 'eine Sprache sprechen',
        't': 'to speak a language'
    },
    {
        'id': 'noun/der-Wert',
        'word': 'Wert, der',
        'english': 'value, worth',
        'sentence': 'Die Teilnehmer des Wettbewerbs erhalten Preise im Wert von 7.000 (siebentausend) Euro.',
        't': 'The participants of the competition will receive prizes worth 7,000 euros.'
    },
    {
        'id': 'noun/die-Gruppe',
        'word': 'Gruppe, die',
        'english': 'group',
        'sentence': 'Letzten Sommer war ich mit einer Gruppe in Österreich wandern.',
        't': 'Last summer I went hiking with a group in Austria.'
    },
    {
        'id': 'noun/der-Anfang',
        'word': 'Anfang, der',
        'english': 'beginning, start',
        'sentence': 'Wer Anfang Dezember geboren ist, hat das Sternzeichen Schütze.',
        't': 'Those born at the beginning of December have the star sign Sagittarius.'
    },
    {
        'id': 'noun/der-Moment',
        'word': 'Moment, der',
        'english': 'moment',
        'sentence': 'der Moment = der Zeitpunkt = der Augenblick',
        't': 'moment'
    },
    {
        'id': 'noun/der-Ort',
        'word': 'Ort, der',
        'english': 'place, town, location, site, spot',
        'sentence': 'Freiburg ist ein Ort in Süddeutschland, nahe der französischen Grenze.',
        't': 'Freiburg is a town in southern Germany near the French border.'
    },
    {
        'id': 'noun/das-Recht',
        'word': 'Recht, das',
        'english': 'right, law',
        'sentence': 'Sie haben das Recht zu schweigen.',
        't': 'You have the right to remain silent.'
    },
    {
        'id': 'noun/das-Interesse',
        'word': 'Interesse, das',
        'english': 'interest',
        'sentence': 'Sind gemeinsame Interessen wichtig für eine gute Beziehung?',
        't': 'Are common interests important for a good relationship?'
    },
    {
        'id': 'noun/die-Folge',
        'word': 'Folge, die',
        'english': 'result, consequence, episode, sequence',
        'sentence': 'Kopf-, Nacken- oder Rückenschmerzen können die Folge einer schlechten Haltung am Arbeitsplatz sein.',
        't': 'Head, neck or back pain can be the result of poor posture at work.'
    },
    {
        'id': 'noun/die-Milliarde',
        'word': 'Milliarde, die',
        'english': 'billion',
        'sentence': 'Tausend Millionen sind eine Milliarde.',
        't': 'A thousand million is a billion.'
    },
    {
        'id': 'noun/der-Text',
        'word': 'Text, der',
        'english': 'text',
        'sentence': 'einen Text, einen Artikel, eine Rede schreiben / verfassen',
        't': 'to write a text, a speech, an article'
    },
    {
        'id': 'noun/das-Ergebnis',
        'word': 'Ergebnis, das',
        'english': 'result, outcome',
        'sentence': 'Ich bin recht zufrieden mit dem Ergebnis. Ein paar Kleinigkeiten lassen sich noch verbessern.',
        't': 'I am quite happy with the result. There are a few small things that can be improved.'
    },
    {
        'id': 'noun/die-Bedeutung',
        'word': 'Bedeutung, die',
        'english': 'meaning, significance, importance',
        'sentence': 'Die Wörter "deshalb", "deswegen", "darum" und "daher" haben alle dieselbe Bedeutung.',
        't': 'The words "therefore", "therefore", "therefore" and "therefore" all have the same meaning.'
    },
    {
        'id': 'noun/der-Schüler',
        'word': 'Schüler, der',
        'english': 'pupil, student',
        'sentence': 'Wie viele Schüler sind in deiner Klasse?',
        't': 'How many students are there in your class?'
    },
    {
        'id': 'noun/die-Rolle',
        'word': 'Rolle, die',
        'english': 'roll, role',
        'sentence': 'Wir müssen Klopapier (ugs.) kaufen. Es ist nur noch eine Rolle da.',
        't': 'We have to buy toilet paper. There is only one roll left.'
    },
    {
        'id': 'noun/die-Tür',
        'word': 'Tür, die',
        'english': 'door',
        'sentence': 'Könntest du die Tür hinter dir zumachen? (ugs.)',
        't': 'Could you close the door behind you?'
    },
    {
        'id': 'noun/der-Krieg',
        'word': 'Krieg, der',
        'english': 'war',
        'sentence': 'einen Krieg führen',
        't': 'to wage a war'
    },
    {
        'id': 'noun/das-Gespräch',
        'word': 'Gespräch, das',
        'english': 'conversation, talk, chat',
        'sentence': 'ein Gespräch führen',
        't': 'to conduct a conversation'
    },
    {
        'id': 'noun/das-Stück',
        'word': 'Stück, das',
        'english': 'piece, part, bit',
        'sentence': 'Möchtest du ein Stück Kuchen?',
        't': 'Would you like a piece of cake?'
    },
    {
        'id': 'noun/der-Punkt',
        'word': 'Punkt, der',
        'english': 'dot, point, period, spot, item',
        'sentence': 'Kommen wir nun zum nächsten Punkt der Tagesordnung.',
        't': 'Let us now move on to the next item on the agenda.'
    },
    {
        'id': 'noun/die-Weise',
        'word': 'Weise, die',
        'english': 'way, manner',
        'sentence': 'Je nach Region wird das Gericht mit verschiedenen Zutaten auf eine bestimmte Art und Weise zubereitet.',
        't': 'Depending on the region, the dish is prepared with different ingredients in a certain way.'
    }
]